import React, { useState } from "react";
import Dropdown from "./dropDown";
import { v4 as uuid } from "uuid";
import NameSelection from "./nameSelection";
import Medications from "./medications";
import SocialHistory from "./socialHistory";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import IconButton from "@mui/material/IconButton";
import Lab from "./lab";

const Categories = [
  "note",
  "lab",
  "procedure",
  "radiology",
  "surgery",
  "pathology",
  "referral",
  "fax",
  "insurance",
  "undetermined",
];

function categorize_pages(packet) {
  var categoryPages = new Object();
  for (var key in packet) {
    var current = packet[key];
    var curDate = current.Date;
    try {
      var candCategories = current.Category.split(" ");
      let posTime = curDate.indexOf("00:00:00");
      curDate = curDate.slice(0, posTime);

      var c = candCategories[0];
      if (Categories.includes(c)) {
        var currentkeys = Object.keys(categoryPages);
        //Creates array associated with key if key doesn't exist yet
        if (!currentkeys.includes(c)) {
          categoryPages[c] = [];
        }
        categoryPages[c].push([current.Pages.map((page) => page), curDate]);
      }
    } catch (e) {}
  }

  // Sort each array in categoryPages by most recent date to least recent date
  for (var key in categoryPages) {
    categoryPages[key].sort((a, b) => new Date(b[1]) - new Date(a[1]));
  }

  return categoryPages;
}

const LeftPortion = ({ data }) => {
  const [showTableOfContents, setShowTableOfContents] = useState(true);
  const [showMedications, setShowMedications] = useState(false);
  const [showLabTables, setShowLabTables] = useState(false);
  const [showSocialHistory, setShowSocialHistory] = useState(false);

  var pagesObjects = categorize_pages(data);
  var pageKeys = Object.keys(pagesObjects);

  pageKeys.sort(function (a, b) {
    return Categories.indexOf(a) - Categories.indexOf(b);
  });

  return (
    <>
      <div
        style={{
          padding: "2%",
          paddingRight: "2%",
          paddingTop: "3%",
          maxWidth: "100%",
          width: "100%",
        }}
        className="flex flex-col space-y-4 items-start"
      >
      
      {/* TABLE OF CONTENTS */}
      <div
        style={{
          height: "auto",
          maxHeight: showTableOfContents ? "88vh" : "60px", // Set the maximum height to 90vh
          width: "100%",
          background: "#F2F4F7",
          borderRadius: "10px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          transition: "height 0.4s ease-in-out", // Add transition for height
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            background: "#F2F4F7",
            zIndex: 1,
          }}
        >
          <h1
            style={{
              fontSize: "26px",
              paddingTop: "10px",
              paddingLeft: "20px",
              textAlign: "left", // Align h1 to left
            }}
          >
            Table of Contents
          </h1>

          <div style={{ 
            top: "1%", 
            paddingRight: "3%",
            }}>
            <IconButton
              onClick={() => setShowTableOfContents(!showTableOfContents)}
              size="large"
              // sx={{ fontSize: "15px" }}
            >
              {showTableOfContents ? (
                <ExpandLessIcon size="large" sx={{ fontSize: "35px" }} />
              ) : (
                <ExpandMoreIcon size="large" sx={{ fontSize: "35px" }} />
              )}
            </IconButton>
          </div>
        </div>

        <div
          style={{
            maxHeight: showTableOfContents ? "80vh" : "60px",
            overflow: "auto",
            transition: "height 1s ease-in-out",
            }}
        >
          {pageKeys.map((k) => {
            var id = uuid();
            return (
              <div
                style={{
                  marginBottom: "10px",
                  display: showTableOfContents ? "block" : "none",
                  transition: "background-color 0.5s ease-in-out",
                }}
              >
                <Dropdown
                  name={k}
                  data={pagesObjects[k]}
                  key={id}
                  className="mr-4"
                />
              </div>
            );
          })}
        </div>
      </div>

        {/* SOCIAL HISTORY*/}
        <div
          style={{
            height: "auto",
            maxHeight: showSocialHistory ? "88vh" : "60px",
            width: "100%",
            overflow: "auto",
            background: "#F2F4F7",
            borderRadius: "10px",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            transition: "height 0.4s ease-in-out", // Add transition for height
            
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "sticky",
              top: 0,
              background: "#F2F4F7",
              zIndex: 1,
            }}
          >
            <h1
              style={{
                fontSize: "26px",
                paddingTop: "10px",
                paddingLeft: "20px",
                textAlign: "left", // Align h1 to left
                alignItems: "center", 
              }}
            >
              Social & Medical History
            </h1>
            <div style={{ top: "1%", paddingRight: "3%" }}>
              <IconButton
                onClick={() => setShowSocialHistory(!showSocialHistory)}
                size="large"
                // sx={{ fontSize: "15px" }}
              >
                {showSocialHistory ? (
                  <ExpandLessIcon size="large" sx={{ fontSize: "35px" }} />
                ) : (
                  <ExpandMoreIcon size="large" sx={{ fontSize: "35px" }} />
                )}
              </IconButton>
            </div>
          </div>
          <div
            style={{
              maxHeight: showSocialHistory ? "80vh" : "60px",
              overflow: "auto",
              transition: "height 1s ease-in-out",
            }}
          >
            <div
              style={{
                marginBottom: "10px",
                display: showSocialHistory ? "block" : "none",
                transition: "background-color 0.5s ease-in-out",
              }}
            >
              <SocialHistory data={data} />
            </div>
          </div>
        </div>
      
      {/* MEDICATIONS */}
      <div
        style={{
          height: "auto",
          maxHeight: showMedications ? "88vh" : "60px",
          maxHeight: "95vh", // Set the maximum height to 90vh
          width: "100%",
          overflow: "auto",
          background: "#F2F4F7",
          borderRadius: "10px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          transition: "height 0.4s ease-in-out", // Add transition for height
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            background: "#F2F4F7",
            zIndex: 1,
          }}
        >
          <h1
            style={{
              fontSize: "26px",
              paddingTop: "10px",
              paddingLeft: "20px",
              textAlign: "left", // Align h1 to left
            }}
          >
            Medications
          </h1>
          <div style={{ top: "1%", paddingRight: "3%" }}>
            <IconButton
              onClick={() => setShowMedications(!showMedications)}
              size="large"
              // sx={{ fontSize: "15px" }}
            >
              {showMedications ? (
                <ExpandLessIcon size="large" sx={{ fontSize: "35px" }} />
              ) : (
                <ExpandMoreIcon size="large" sx={{ fontSize: "35px" }} />
              )}
            </IconButton>
          </div>
        </div>
        <div
          style={{
            maxHeight: showMedications ? "80vh" : "60px",
            overflow: "auto",
            transition: "height 1s ease-in-out",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              display: showMedications ? "block" : "none",
              transition: "background-color 0.5s ease-in-out",
            }}
          >
            <Medications
              data={data}
              style={{ width: "100%", maxWidth: "100%" }}
            />
          </div>
        </div>
      </div>
      {/* LAB VALUES */}
      <div
        style={{
          height: "auto",
          maxHeight: showLabTables ? "88vh" : "60px",
          width: "100%",
          overflow: "auto",
          background: "#F2F4F7",
          borderRadius: "10px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          transition: "height 0.4s ease-in-out", // Add transition for height
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            background: "#F2F4F7",
            zIndex: 1,
          }}
        >
          <h1
            style={{
              fontSize: "26px",
              paddingTop: "10px",
              paddingLeft: "20px",
              textAlign: "left", // Align h1 to left
            }}
          >
            Lab Values
          </h1>
          <div style={{ top: "1%", paddingRight: "3%" }}>
            <IconButton
              onClick={() => setShowLabTables(!showLabTables)}
              size="large"
              // sx={{ fontSize: "15px" }}
            >
              {showLabTables ? (
                <ExpandLessIcon size="large" sx={{ fontSize: "35px" }} />
              ) : (
                <ExpandMoreIcon size="large" sx={{ fontSize: "35px" }} />
              )}
            </IconButton>
          </div>
        </div>
        <div
          style={{
            maxHeight: showLabTables ? "80vh" : "60px",
            overflow: "auto",
            transition: "height 1s ease-in-out",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              display: showLabTables ? "block" : "none",
              transition: "background-color 0.5s ease-in-out",
            }}
          >
            <Lab data={data} style={{ width: "100%", maxWidth: "100%" }} />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default LeftPortion;
